import React, { useRef, useEffect, useState } from 'react';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import LiveCampaignItem from '../live-campaigns/LiveCampaignItem'
import MissingIcon from '../../../images/missing.jpg';

// Import utilities
import { tailwindConfig, formatValue } from '../../../utils/Utils';

function TimelineCard({notifs}) {

  const storage = getStorage();
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if(notifs.length>0)
      updateSteps()
  }, [notifs]);

  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});

  async function updateSteps(){
    for(var notif of notifs) {
      notif['icon'] = await getDownloadURL(storageRef(storage, notif.package + '.jpg'))
    }
    setSteps(notifs)
  }

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
        steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  return (
    <div className="my-10">
      {steps.length>0?
        <div>
          <div className="py-5 flex justify-items">
            <div className="text-sm inline-flex font-medium bg-pink-100 text-pink-600 rounded-full text-center px-2.5 py-1">
              {steps[activeStep].audience}
            </div>
          </div>
          <Box sx={{ width: '100%' }}>
            <Stepper nonLinear activeStep={activeStep}>
              {
                steps.map((item, index) => (
                  <Step key={index} completed={completed[index]}>
                    <StepButton color="inherit" onClick={handleStep(index)}>
                      {item.hour + ':' + (item.minute>9?item.minute:'0'+item.minute)}
                    </StepButton>
                  </Step>))
              }
            </Stepper>
            <div>
              <React.Fragment>
                  <div className="mt-5 mb-1">
                    <LiveCampaignItem title={steps[activeStep].title} text={steps[activeStep].text}
                                       image={steps[activeStep].icon} app={steps[activeStep].app} date={steps[activeStep].date}/>
                  </div>
                  {/*<Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}>Back </Button>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <Button onClick={handleNext} sx={{ mr: 1 }}>
                      Next
                    </Button>
                  </Box>*/}
              </React.Fragment>
            </div>
          </Box>
        </div>:''
      }
    </div>

  );
}

export default TimelineCard;